// import Alpine from '../../vendor/livewire/livewire/dist/livewire.esm';
import _ from "lodash";

Alpine.store('packageData', {
    index: null,
    athlete: null,
    jersey: null,
    images: {},
    saved: false,
    exceptIndex: null,

    set({ index = null, athlete = null, jersey = null, images = {}, saved = false }){
        this.index = index;
        this.saved = saved;
        this.jersey = jersey;
        this.athlete = athlete;
        this.images =Object.assign({}, images);
    },

    get(){
        return {
            index: this.index,
            athlete: this.athlete,
            jersey: this.jersey,
            images: this.images,
            saved: this.saved,
        };
    },

    imagesQuantity(){
        return Object.values(this.images)
            .reduce(
                (quantity, images) => quantity + Object.values(images).length
                , 0
            );
    },

    exceptRequirement(index){
        this.exceptIndex = index;

        return this;
    },

    hasImage(imageId, requirementIndex = null){
        if (! requirementIndex) {
            return Object.keys(this.images)
                .filter((requirement) => requirement != this.exceptIndex)
                .some((requirement) => {
                    return Object.values(this.images[requirement]).findIndex(({id}) => id === imageId) > -1
                });
        }

        const images = _.get(this.images, requirementIndex, []);

        return images
            ? images.findIndex(({id}) => id === imageId) > -1
            : false;
    },

    getImage(requirementIndex, imageIndex) {
        const images = Object.values(
            _.get(this.images, requirementIndex, [])
        );

        return _.get(images, imageIndex-1, {});
    },
});
